import type { PathSegment } from '@/types';

import isValidSegment from '@/utils/helpers/is-valid-segment';

const envVariables = import.meta.env;

const { VITE_APP_DOMAIN } = envVariables;

const BASE_API_URL = `${VITE_APP_DOMAIN}/api/v1`;

const buildApiUrlWithParams = (
  basePath: string,
  ...args: (PathSegment | Record<string, unknown>)[]
): string => {
  const mutableArgs = [...args];
  const lastArg = mutableArgs[mutableArgs.length - 1];

  const queryParams =
    lastArg && typeof lastArg === 'object' && !Array.isArray(lastArg)
      ? (mutableArgs.pop() as Record<string, unknown>)
      : undefined;

  const pathParts = [basePath, ...(mutableArgs as PathSegment[])]
    .filter(isValidSegment)
    .map(String);
  let url = `${BASE_API_URL}/${pathParts.join('/')}`;

  if (queryParams) {
    const validEntries = Object.entries(queryParams)
      .filter(([, value]) => value !== null)
      .map(([key, value]) => [key, String(value)]);

    if (validEntries.length > 0) {
      const searchParams = new URLSearchParams(validEntries);
      url += `?${searchParams.toString()}`;
    }
  }

  return url;
};

export default buildApiUrlWithParams;
